import { useState } from 'react';

const CORRECT = 'PMI2026';
const STORAGE_KEY = 'pmi-auth';

export const PasswordGate = ({ children }) => {
  const [unlocked, setUnlocked] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch { return false; }
  });
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);

  const attempt = () => {
    if (value === CORRECT) {
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch {}
      setUnlocked(true);
    } else {
      setError(true);
      setShake(true);
      setValue('');
      setTimeout(() => setShake(false), 600);
    }
  };

  const handleKey = (e) => {
    if (e.key === 'Enter') attempt();
    else setError(false);
  };

  if (unlocked) return children;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center px-4"
      style={{ background: '#06101C' }}
    >
      {/* subtle background glow */}
      <div className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 60% 40% at 50% 50%, rgba(200,117,51,0.07) 0%, transparent 70%)',
        }}
      />

      <div
        className="relative w-full max-w-sm"
        style={{
          animation: shake ? 'pw-shake 0.5s ease' : undefined,
        }}
      >
        {/* Logo */}
        <div className="flex items-center justify-center mb-10">
          <img src="/wibe-logo.png" alt="Wibe Solutions" className="h-16 w-auto" />
        </div>

        {/* Card */}
        <div
          className="rounded-2xl px-8 py-9"
          style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.09)',
            backdropFilter: 'blur(16px)',
          }}
        >
          <div className="flex items-center gap-2 mb-1">
            <span className="w-1.5 h-1.5 rounded-full bg-[#C87533]" />
            <span className="font-mono text-[10px] text-[#C87533] uppercase tracking-[0.2em]">
              Restricted Access
            </span>
          </div>
          <h2 className="font-display text-xl font-bold text-white mb-1 mt-3">
            Dostop zaščiten
          </h2>
          <p className="text-white/40 text-sm mb-7">
            Vnesite geslo za dostop.
          </p>

          <input
            type="password"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={handleKey}
            placeholder="••••••••"
            autoFocus
            className="w-full rounded-xl px-4 py-3.5 text-sm font-mono text-white outline-none transition-all duration-200 mb-3"
            style={{
              background: 'rgba(255,255,255,0.05)',
              border: `1px solid ${error ? 'rgba(239,68,68,0.6)' : 'rgba(255,255,255,0.1)'}`,
              caretColor: '#C87533',
            }}
          />

          {error && (
            <p className="text-red-400 text-xs font-mono mb-3 text-center">
              Napačno geslo. Poskusite znova.
            </p>
          )}

          <button
            onClick={attempt}
            className="w-full rounded-xl py-3.5 text-sm font-semibold text-white transition-all duration-200"
            style={{
              background: 'linear-gradient(135deg, #C87533, #FF8C2A)',
              boxShadow: '0 4px 20px rgba(200,117,51,0.35)',
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
          >
            Vstopi
          </button>
        </div>

        <p className="text-center text-white/20 text-xs font-mono mt-6">
          © 2026 Wibe Solutions d.o.o.
        </p>
      </div>

      <style>{`
        @keyframes pw-shake {
          0%,100% { transform: translateX(0); }
          15%      { transform: translateX(-8px); }
          30%      { transform: translateX(8px); }
          45%      { transform: translateX(-6px); }
          60%      { transform: translateX(6px); }
          75%      { transform: translateX(-3px); }
          90%      { transform: translateX(3px); }
        }
      `}</style>
    </div>
  );
};
